// extracted by mini-css-extract-plugin
export var closeButton = "_f-1";
export var container = "_f-0";
export var fullModalImage = "_f-2";